import React from "react";
import GlobalFilter from "@/Utility/GlobalFilter/GlobalFilter";

const BacklogFilter = ({
  listingFilter,
  handleFilterChange,
  handleFilterReset,
  applyFilters,
  assigneeOptions = [],
  priorityOptions = [],
  statusOptions = [],
}) => {
  const fields = [
    {
      type: "input",
      name: "search",
      label: "Issue",
      placeholder: "Search issue / key",
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      options: statusOptions,
      placeholder: "Select Status",
    },
    {
      type: "dropdown",
      name: "priority",
      label: "Priority",
      options: priorityOptions,
      placeholder: "Select Priority",
    },
    {
      type: "dropdown",
      name: "assignee",
      label: "Assignee",
      options: assigneeOptions,
      placeholder: "Select Assignee",
      searchable: true,
    },
  ];

  return (
    <GlobalFilter
      listingFilter={listingFilter}
      handleFilterChange={handleFilterChange}
      handleFilterReset={handleFilterReset}
      applyFilters={applyFilters}
      fields={fields}
      columns={3}
      containerClassName="bg-white border rounded-lg mb-4"
      label="Backlog Filters"
    />
  );
};

export default BacklogFilter;
